(function () {
  function formatNumber(value) {
    return Number(value || 0).toLocaleString('en-AU');
  }

  function animateCounter(counter) {
    if (!counter || counter.dataset.animated === 'true') return;

    const shouldAnimate = counter.dataset.animate === 'true';
    const staticValue = counter.dataset.staticValue || '';
    const target = parseFloat((counter.dataset.target || '').replace(/,/g, ''));
    const prefix = counter.dataset.prefix || '';
    const suffix = counter.dataset.suffix || '';

    if (!shouldAnimate || staticValue || Number.isNaN(target)) {
      if (staticValue) {
        counter.textContent = staticValue;
      } else {
        counter.textContent = prefix + formatNumber(target || 0) + suffix;
      }

      counter.dataset.animated = 'true';
      return;
    }

    const duration = 1500;
    const startTime = performance.now();

    function update(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(eased * target);

      counter.textContent = prefix + formatNumber(current) + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = prefix + formatNumber(target) + suffix;
        counter.dataset.animated = 'true';
      }
    }

    requestAnimationFrame(update);
  }

  function setupStatScroller(section) {
    const track = section.querySelector('[data-itf-sus-stats-track]');
    const prev = section.querySelector('[data-itf-sus-prev]');
    const next = section.querySelector('[data-itf-sus-next]');

    if (!track) return;

    function getStep() {
      const firstCard = track.querySelector('.itf-sustainability__stat');
      if (!firstCard) return track.clientWidth * 0.8;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 12) || 12;

      return firstCard.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({
          left: -getStep(),
          behavior: 'smooth'
        });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({
          left: getStep(),
          behavior: 'smooth'
        });
      });
    }

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    track.addEventListener('pointerdown', function (event) {
      if (window.matchMedia('(min-width: 521px)').matches) return;

      isDown = true;
      startX = event.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;

      const walk = event.clientX - startX;
      track.scrollLeft = scrollLeft - walk;
    });

    function stopDrag(event) {
      if (!isDown) return;

      isDown = false;
      track.classList.remove('is-dragging');

      if (event && event.pointerId) {
        try {
          track.releasePointerCapture(event.pointerId);
        } catch (error) {
          // Ignore pointer capture release errors.
        }
      }
    }

    track.addEventListener('pointerup', stopDrag);
    track.addEventListener('pointercancel', stopDrag);
    track.addEventListener('pointerleave', stopDrag);
  }

  function initSection(section) {
    if (!section || section.dataset.itfSustainabilityReady === 'true') return;

    section.dataset.itfSustainabilityReady = 'true';

    setupStatScroller(section);

    const counters = Array.from(section.querySelectorAll('[data-itf-sus-counter]'));

    if (!counters.length) return;

    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCounter);
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        counters.forEach(animateCounter);
        observer.disconnect();
      });
    }, {
      threshold: 0.25
    });

    observer.observe(section);
  }

  function initAll(container) {
    const scope = container || document;
    const sections = Array.from(scope.querySelectorAll('[data-itf-sustainability]'));

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();